<template>
  <div class="hotel-dialog-container">
    <el-dialog
      :title="title"
      :visible.sync="visible"
      @close="onDialogClose"
      width="50%"
      center
    >
      <div>
        <el-tree
          :data="powerTree"
          show-checkbox
          :default-expand-all="true"
          node-key="uuid"
          ref="tree"
          :props="defaultProps"
        />
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisibleCancelClick">取消</el-button>
        <el-button
          type="primary"
          @click="dialogConfirmClick"
        >确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommonDialog from "@/components/CommonDialog";
import { mapState } from "vuex";

export default {
  name: "selecthoteldialog",
  data() {
    return {
      powerTree: [],
      defaultProps: {
        children: "hotel_data",
        label: "label"
      },
      visible: this.dialogVisible,
      hotelData: []
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    dialogVisible: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      default: "add"
    },
    hotel_uuid: {
      type: Array
    },
    hotelList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    CommonDialog
  },
  mounted() {
    // console.log(this.brandData, this.hotelData, 'ddddddd')
  },
  computed: {
    ...mapState(["brandData"])
  },
  methods: {
    dialogVisibleCancelClick() {
      this.$emit("cancel");
    },
    dialogConfirmClick() {
      const selectHotel = this.$refs.tree.getCheckedNodes(true);
      if (!selectHotel.length) {
        this.$message("请选择酒店");
        return;
      }
      this.$emit("confirm", selectHotel);
    },
    onDialogClose() {
      this.$emit("close");
    },
    getTreeData() {
      //把所有酒店数据放到对应品牌下面
      const brandData = JSON.parse(JSON.stringify(this.brandData));
      const hotelData = JSON.parse(JSON.stringify(this.hotelList));
      console.log(brandData, hotelData, "hotelData dialog");
      let tree = [];
      brandData.forEach(brand => {
        let hotel_data = [];
        brand.label = brand.brand_name;
        hotelData.forEach(hotel => {
          if (hotel.brand_uuid === brand.uuid) {
            hotel.label = hotel.hotel_name;
            hotel_data.push(hotel);
          }
        });
        if (hotel_data.length) {
          brand.hotel_data = hotel_data;
        } else {
          brand.disabled = true;
        }
      });
      this.powerTree = brandData;
      console.log(brandData, "brand data");
    }
  },
  watch: {
    async dialogVisible(val) {
      this.visible = val;
      if (val) {
        this.getTreeData();
        if (this.type === "edit" && this.hotel_uuid && this.hotel_uuid.length) {
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(this.hotel_uuid);
          });
        } else {
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys([]);
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";

/deep/.el-tree {
  display: flex;
  flex-direction: column;
  .el-tree-node {
    display: inline-block;
    white-space: normal;
  }
}
</style>

